import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

export const useBranchId = () => {
	const locations = useSelector((state) => state.locations);
	const [branchId, setBranchId] = useState(null);

	useEffect(() => {
		let params = new URLSearchParams(window.location.search);
		let branch = params.get('branch');

		if (branch) setBranchId(branch);
	}, []);

	useEffect(() => {
		let params = new URLSearchParams(window.location.search);
		let branch = params.get('branch');

		if (branch) return;

		setBranchId(locations?.showrooms?.[0]?.branch_id);

		// eslint-disable-next-line react-hooks/exhaustive-deps -- stringify necessary for comparison
	}, [branchId, JSON.stringify(locations.showrooms)]);

	return branchId;
};
